/* eslint-disable no-useless-escape */
export const NUMBERS_PATTERN = /^\d+$/;
export const LETTERS_PATTERN = /^[a-zA-Z\s]*$/;
export const EMAIL_PATTERN = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
